import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DarkmodeService } from 'src/app/_provider/darkmode.service';
import { PopoverController } from '@ionic/angular';
import { PopoverPage } from '../popover/popover.page';
import { TransferService } from 'src/app/_provider/transfer.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { SaveService } from 'src/app/_provider/save.service';
import { BreadcumbService } from 'src/app/_provider/breadcumb.service';

@Component({
    selector: 'app-ticket-more',
    templateUrl: './ticket-more.component.html',
    styleUrls: ['./ticket-more.component.scss'],
    standalone: false
})
export class TicketMoreComponent implements OnInit {

  @Input() public isDesktop: boolean
  @Input() public isOpen: boolean
  @Input() public segmentValue: string = "settings"
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>()

  public isDarkmode: boolean
 


  constructor(
    public darkmode: DarkmodeService,
    public popoverController: PopoverController,
    public transfer: TransferService,
    public saveSrv: SaveService.Ticket,
    private breadcrumbSrv: BreadcumbService,
    public resize: ResizeManagerService
    ) {
    darkmode.isDarkMode.subscribe((result: boolean)=>{
      this.isDarkmode = result
    })
  }

  ngOnInit() {

  }


  public segmentChanged(event: any):void{
    this.segmentValue = event.target.value
  }

}
